export function isValidToken(token) {
  return Boolean(
    token
    && token !== 'false'
    && token !== 'null'
    && token !== 'undefined',
  );
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function restoreTokenFromStorage() {
  const storedToken = localStorage.getItem('token');
  if (isValidToken(storedToken)) {
    return storedToken;
  }

  const cookieToken = getCookie('token');
  if (isValidToken(cookieToken)) {
    localStorage.setItem('token', cookieToken);
    return cookieToken;
  }

  return null;
}

export function getStoredToken() {
  return restoreTokenFromStorage();
}

export function clearAuthCookie(name = 'token') {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

export function clearAuthStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('token_expired_on');
  localStorage.removeItem('trusted_device');
  clearAuthCookie('token');
}

export const PUBLIC_ROUTE_NAMES = new Set([
  'FrontPage',
  'FrontPageDesignGallery',
  'FrontPageDesignViewer',
  'TeamPage',
  'Login',
  'ResetPassword',
  'InitiateResetPassword',
  'ConfirmEmail',
  'TryModel',
  'DownloadModel',
]);
